/** Número de contacto (ORIGEN Studio) usado por todos los CTA de la página. */
export const WHATSAPP_NUMBER = '573212747649'

/** Enlace tel: para la barra de acciones móvil. */
export const PHONE_HREF = 'tel:+573212747649'

/**
 * Genera un enlace de WhatsApp con mensaje prellenado.
 */
export function waLink(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
